import React, { useRef } from 'react'
import styles from './style.module.scss';
import Magnetic from '../Projects/Test/common/Magnetic';
import { useScroll, motion, useTransform } from 'framer-motion';

function Index() {

    const container = useRef(null);
    const { scrollYProgress } = useScroll({
        target: container,
        offset: ["start end", "end end"]
    })
    const x = useTransform(scrollYProgress, [0, 1], [0, 100])
    const y = useTransform(scrollYProgress, [0, 1], [-500, 0])
    const rotate = useTransform(scrollYProgress, [0, 1], [120, 90])
  
  



    return (
        <motion.div style={{ y }} ref={container} className={styles.contact}>
          <div className={styles.body}>





         
            
              <div className={styles.info}>
                  <div>
                      <span>
                          <h3>Version</h3>
                          <p>2023 © Edition</p>
                      </span>
                      <span>
                          <h3>Version</h3>
                          <p>11:49 PM GMT+2</p>
                      </span>
                  </div>
                  <div>
                      <span>
                          <h3>socials</h3>
                          <Magnetic>
                          <p>  <a href='https://www.github.com/devshakilh/'>GitHub</a></p>
                          </Magnetic>
                      </span>
                      <Magnetic>
                      <p>  <a href='https://www.linkedin.com/in/devshakilh/'>Linkedin</a></p>
                          
                      </Magnetic>
                      <Magnetic>
                        <p>  <a href='https://www.instagram.com/devshakilh/'>Instagram</a></p>
                      </Magnetic>
                      <Magnetic>
                        
                          <p><a href='https://www.facebook.com/devshakilh/'>Facebook</a></p>
                      </Magnetic>
                     
                  </div>
              </div>
          </div>
      </motion.div>
    )
}

export default Index
